export const REGEX =
  /((https?:\/\/)?(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export const RESET_IFRAME_STYLES = `
  <style>
    *{
      box-sizing: border-box;
    }
    body, html{
      margin: 0;
      padding: 0;
      height:100%;
    }
    iframe{
      width: 100%;
      height:100%;
      display:block;
    }
  </style>
`;

/**
 * Customer-supplied embed HTML is never executed on the host origin. Snippets
 * that are not a plain provider `<iframe>` are rendered by a static "embed
 * shell" page on the assets bucket (a separate origin), which receives the
 * HTML through the URL fragment and writes it into its own document.
 * Providers nested inside (YouTube, Typeform, HubSpot…) keep their real origin,
 * cookies and Referer, so they behave as on any third-party site.
 * Source of the shell: dotell-assets `storydoc/assets/embed/v1/embed.html`.
 */
export const EMBED_SHELL_PATH = "/assets/embed/v1/embed.html";

/**
 * `allow-same-origin` is safe here ONLY because the frame's document lives on
 * the assets origin, never on the host page's origin. Do not reuse this for a
 * `srcDoc` frame — that would hand the embed the host origin (and the Firebase
 * session in IndexedDB).
 */
export const EMBED_SHELL_SANDBOX =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals allow-presentation allow-top-navigation-by-user-activation";

/** Permissions delegated to embeds (needed by nested video players). */
export const EMBED_IFRAME_ALLOW =
  "autoplay; fullscreen; encrypted-media; picture-in-picture; clipboard-write";
